const INITIAL_STATE = {
    taxaEntradaList: [],
    taxaEntrada: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'TAXAENTRADALIST_FETCH':
        return { ...state, taxaEntradaList: action.payload }
      case 'TAXAENTRADA_SET':
        return { ...state, taxaEntrada: action.payload }
      default:
        return state
    }
  }